import { ReactComponent as Shopify } from '@wellbeingxltd/fe-lib/images/dist/icons/shopify.svg'
import { IoCellularOutline, IoFileTrayFullOutline, IoLayersOutline, IoSettingsOutline, IoTicketOutline } from 'react-icons/io5'
import { SUPPLIERS_PERMISSIONS_TO_VIEW } from '@wellbeingxltd/fe-lib/constants'

const ICONS = {
    transactions: IoLayersOutline,
    directory: IoCellularOutline,
    invoices: IoFileTrayFullOutline,
    shopify: Shopify,
    settings: IoSettingsOutline,
    vouchers: IoTicketOutline,
}

export const getAllButtons = () =>
    Object.entries(SUPPLIERS_PERMISSIONS_TO_VIEW).map(([key, object]) => ({
        ...object,
        title: object.label,
        Icon: ICONS[object.payload],
        size: '24px',
    }))
